import { render } from "./App.vue?vue&type=template&id=b3fc2f26"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b3fc2f26&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\travelsite-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__